import { map, Subject } from 'rxjs';
import { ORANGEOTT } from '../core/media/types';
import { deepMerge, Logger } from '../utils';
import { DEFAULT_TYPE, MESSAGE_DEFAULT } from './definitions';
import { DEFAULT_ORANGE_ERROR, ORANGE_ERRORS_MAP, replaceHashTagWithMessage } from './orange';

export default function error(
  original = {},
  override = {}
) {
  const {
    code,
    message,
    type,
    fatal,
    canRecover,
    canRetry,
    showCode,
    payload,
    refresh,
    description,
    ip
  } = { ...original, ...override };
  const e = Object.create(new Error());
  e.code = code || 5000;
  e.message = message || MESSAGE_DEFAULT;
  e.fatal = fatal || false;
  e.type = type || DEFAULT_TYPE;
  e.canRecover = canRecover || false;
  e.canRetry = typeof canRetry === 'boolean' ? canRetry : true;
  e.showCode = typeof showCode === 'boolean' ? showCode : true;
  e.payload = payload || {};
  e.refresh = refresh || null;
  e.description = description || 'no information';
  e.ip = ip || null;

  return e;
}

export class ErrorController {
  constructor(player, platform, decorators) {
    this.errors$ = new Subject();

    ErrorController.createDecorationErrorStream(this.errors$, platform, decorators)
      .subscribe(player.errors$);

    player.errors$.subscribe(({ error: e }) => {
      Logger[e.fatal ? 'error' : 'warn'](e.type, e);
    });
  }

  static getOrangeError(code) {
    const { codes, ...e } = ORANGE_ERRORS_MAP.find(({ codes: cds }) => (cds.includes(code))) || DEFAULT_ORANGE_ERROR;
    return e;
  }

  static createDecorationErrorStream(errors$, platform, decorators) {
    return errors$.pipe(
      map(({ error: e }) => (platform === ORANGEOTT
        ? {
          error: replaceHashTagWithMessage(
            deepMerge(e, ErrorController.getOrangeError(e.code)),
            e.message || ''
          )
        }
        : { error: e }
      )),
      ...decorators
    );
  }
}
